import { Box } from "@mui/material";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { functionURLService } from "./functionalurl";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom';
import Sidebar from "./Sidebar/Sidebar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const Wel = () => {
  const { id, token } = useParams();
  const navigate = useNavigate(); 
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  // useEffect(() => {
  //   console.log("response");
  //   if (id && token) {
  //     authenticateUser();
  //   } else {
  //     validateApiToken();
  //   }
  // }, []);
  // const validateApiToken = () => {
  //   const tokenExist = validateToken("username", "url_token");
  //   if (!tokenExist) {
  //     handleOpen();
  //   }
  // };
  // const validateToken = (user, token) => {
  //   let userExist = localStorage.getItem(user);
  //   let tokenExist = localStorage.getItem(token);
  //   console.log("User Exist:", userExist);
  //   console.log("Token Exist:", tokenExist);

  //   return tokenExist && userExist;
  // };

  // const authenticateUser = async () => {
  //   try {
  //     setOpen(true);
  //     functionURLService(
  //       "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws",
  //       JSON.stringify({
  //         user_id: Number(id),
  //         url_token: token,
  //       }),
  //       "/authenticateuser"
  //     )
  //       .then((response) => {
  //         console.log(response.data.status);
  //         console.log("Authentication response:", response.data);
  //         setOpen(false);
  //         if (response.data.status === "success") {
  //           localStorage.setItem("username", id);
  //           localStorage.setItem("url_token", token);
  //           navigate(`/inventory_billing/${parseInt(id, 10)}`);

  //         } else {
  //           handleOpen();
  //           setOpenModal(true);
  //         }
  //       })
  //       .catch((error) => {
  //         setOpen(false);
  //         setOpenModal(true);
  //         console.log(error);
  //       });
  //   } catch (error) {
  //     setOpenModal(true);
  //     console.log(error);
  //   }
  // };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p:7,bgcolor:"#f2f6fc",height:"450%",
      fontFamily: `"Metropolis", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      fontWeight: 500,color:"#353d47",fontSize:'1.6rem'}}>
        Welcome
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2 style={{ textAlign: "center" }}>Login Required</h2>
          <h3 style={{ textAlign: "center" }}>
            You are not logged into SSP portal. Please login to proceed
          </h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={() =>
                (window.location.href = "https://ssp.moreconnect.in/loginv2")
              }
            >
              Go to Portal
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Wel;
